import { useAuth } from '../../context/AuthContext';
import { Bell, Search, Settings, User, Menu } from 'lucide-react';
import { formatLongDate } from '../../utils/format';

const Topbar = ({ onMenuClick = () => {} }) => {
  const { user } = useAuth();

  // Browser-locale date (no hard-coded en-US) via the shared util.
  const today = formatLongDate();

  return (
    <header className="h-24 bg-white/50 backdrop-blur-md border-b border-slate-100 px-4 sm:px-6 lg:px-10 flex items-center justify-between z-10">
      <div className="flex items-center space-x-4 lg:space-x-8">
        <button
          onClick={onMenuClick}
          aria-label="Toggle menu"
          className="p-2.5 -ml-1 text-slate-500 hover:text-slate-900 hover:bg-slate-50 rounded-xl transition-all"
        >
          <Menu className="w-6 h-6" />
        </button>
        <div>
          <p className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-1">Today's Date</p>
          <p className="text-sm font-bold text-slate-600">{today}</p>
        </div>
        <div className="h-10 w-px bg-slate-100 hidden md:block"></div>
        <div className="relative hidden lg:block">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-300" />
          <input 
            type="text" 
            placeholder="Search platform..." 
            className="pl-10 pr-4 py-2 bg-slate-50 border-none rounded-full text-xs font-medium w-64 focus:ring-2 focus:ring-primary-500/20 transition-all outline-none"
          />
        </div>
      </div>

      <div className="flex items-center space-x-6">
        <div className="flex space-x-2">
          <button aria-label="Notifications" className="p-2.5 text-slate-400 hover:text-slate-900 hover:bg-slate-50 rounded-xl transition-all relative">
            <Bell className="w-5 h-5" />
            <span className="absolute top-2 right-2 w-2 h-2 bg-rose-500 rounded-full border-2 border-white"></span>
          </button>
          <button aria-label="Settings" className="p-2.5 text-slate-400 hover:text-slate-900 hover:bg-slate-50 rounded-xl transition-all">
            <Settings className="w-5 h-5" />
          </button>
        </div>

        <div className="h-10 w-px bg-slate-100"></div>

        <div className="flex items-center space-x-4 pl-2">
          <div className="text-right">
            <p className="text-sm font-black text-slate-900 leading-tight">
              {user?.email || 'Administrator'}
            </p>
            <p className="text-[10px] font-bold text-primary-600 uppercase tracking-wider">
              {user?.role || 'Super Admin'}
            </p>
          </div>
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-slate-800 to-slate-950 flex items-center justify-center text-white shadow-lg shadow-slate-200">
            <User className="w-6 h-6" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Topbar;
